import { render, staticRenderFns } from "./UploadVideo.vue?vue&type=template&id=3050cf62&scoped=true&"
import script from "./UploadVideo.vue?vue&type=script&lang=js&"
export * from "./UploadVideo.vue?vue&type=script&lang=js&"
import style0 from "./UploadVideo.vue?vue&type=style&index=0&id=3050cf62&prod&lang=scss&scoped=true&"
import style1 from "./UploadVideo.vue?vue&type=style&index=1&id=3050cf62&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3050cf62",
  null
  
)

export default component.exports